import { computed, watch } from 'vue';
import { pageThemeForPath } from '@/js/core/utils/page-theme';

/**
 * Keeps document body dataset values aligned with route and timezone state.
 */
export function useBodyDatasetSync(route, currentPageStore, timezoneStore, appStateStore) {
  const body = document.querySelector('body');

  // Routes may pin a theme when they have no page of their own to take it from — /profile is
  // rendered entirely by Vue. Otherwise it comes from the page's ACF background style, looked
  // up per route so a client-side push re-themes the body; currentPage only ever describes the
  // page this document booted on, so it cannot answer for a route pushed later.
  const bodyTheme = computed(
    () =>
      route.meta.theme ||
      pageThemeForPath(appStateStore?.pageThemes, route.path) ||
      currentPageStore.backgroundColour ||
      ''
  );

  watch(
    bodyTheme,
    newValue => {
      body.dataset.theme = newValue;
    },
    { immediate: true }
  );

  watch(
    () => timezoneStore.timezone,
    newValue => {
      body.dataset.timezone = newValue;
    }
  );

  watch(
    () => timezoneStore.timezoneOption,
    newValue => {
      body.dataset.timezoneOption = newValue;
    }
  );

  watch(
    () => timezoneStore.timeDifference,
    newValue => {
      body.dataset.timeDifference = newValue;
    }
  );

  const syncInitialTimezoneDataset = () => {
    body.dataset.timezone = timezoneStore.timezone;
    body.dataset.timezoneOption = timezoneStore.timezoneOption;
  };

  return {
    syncInitialTimezoneDataset,
  };
}
